export default "__VITE_ASSET__CEHZbpID__"